export const HiddenBalanceText = "****";
